import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { DienstenPage } from "@/pages/diensten";

export const Route = createFileRoute("/$lang/services")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/diensten",
      title: t("diensten.title"),
      description: t("diensten.description"),
    });
  },
  component: DienstenPage,
});
